import { CartItemState, ICartParticipant } from 'types/cart';

interface BookingDraft {
  participants: ICartParticipant[];
}

interface NextBookingStepParams {
  askParticipantsInfo: boolean;
  hasBookableAddOns: boolean;
  hasCustomQuestions: boolean;
  hasResourceOptions: boolean;
  participantsRoute: string;
}

// The API still needs a name per participant when the guest is never asked for one.
const withPlaceholderParticipants = <T extends BookingDraft>(cartData: T) => ({
  ...cartData,
  maxParticipantReached: '',
  additionalCustomQuestionResponses: {},
  participants: cartData.participants.map((participant) => ({
    ...participant,
    fullName: 'Resource Purchaser',
    firstName: 'Resource',
    lastName: 'Purchaser',
  })),
});

/** The step after the session picker: add-ons, then participants, then checkout. */
const deriveNextBookingStep = <T extends BookingDraft>(
  cartData: T,
  {
    askParticipantsInfo,
    hasBookableAddOns,
    hasCustomQuestions,
    hasResourceOptions,
    participantsRoute,
  }: NextBookingStepParams,
) => {
  if (hasBookableAddOns) {
    return {
      cartData: askParticipantsInfo
        ? cartData
        : withPlaceholderParticipants(cartData),
      route: '/addons/{cartItemId}',
    };
  }

  if (askParticipantsInfo || hasCustomQuestions || hasResourceOptions) {
    return { cartData, route: participantsRoute };
  }

  return {
    cartData: {
      ...withPlaceholderParticipants(cartData),
      state: CartItemState.READY,
    },
    route: '/checkout',
  };
};

export default deriveNextBookingStep;
